import D1 from "../../components/ExcerciseTypes/Design/TypeIn";
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write';
import UI from "../../components/ExcerciseTypes/Design/UserInterface";

const json = {
  1: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P43-E1',
    audio: 'img/FriendsPlus/Page43/Audio/audio-e1-p43.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page43/E1/1.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/2.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/tieude-e1-p43.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page43/E1/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page43/E1/5.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/6.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/sm.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/7.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/8.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/sn.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/9.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/10.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/st.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/11.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/12.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/sk.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/13.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page43/E1/14.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/15.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/smile.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/16.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/17.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/snow.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/18.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/19.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/star.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/20.jpg' },
        { url: 'img/FriendsPlus/Page43/E1/21.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/sky.mp3' },
        { url: 'img/FriendsPlus/Page43/E1/22.jpg' },
      ],
    ],
  },
  2: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P43-E2',
    audio: 'img/FriendsPlus/Page43/Audio/audio-e2-p43.mp3',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [ // Row
      [
        // Column1
        { url: 'img/FriendsPlus/Page43/E2/1.jpg' },
        { url: 'img/FriendsPlus/Page43/E2/2.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/tieude-e2-p43.mp3' },
        { url: 'img/FriendsPlus/Page43/E2/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page43/E2/4.jpg' },
      ],
    ],
  },
  3: { // Exercise num
    // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P43-E3',
    audio: '',
    video: '',
    component: Circle_Write,
    exerciseKey: 'img/FriendsPlus/Page43/E3/Key/answerKey.png',
    titleQuestion: [{ num: '3', title: 'Read the chant again. Circle the sounds sm, sn, st, and sk.', color: "#1F4199" }],
    question: {
      Write: {
        inputStyle: {},
        answers: [],
        initialValue: [],
      },
      Circle: {
        // initialWordStyle: { margin: '5px 0', border: 'solid 2px', borderColor: 'black', borderRadius: '50%', padding: '0 5px' },
        initialWordStyle: { margin: '5px 0', border: 'none', borderColor: 'transparent', borderRadius: '50%' },
        selectWordStyle: { border: 'solid 2px', borderColor: '#00a8ec', padding: '0 5px' },
        listWords: [
          'Lo|ok at th|e sn|ake',//0
          'In th|e sn|ow.',//1
          'A sn|ake wi|th a sm|ile.',//2
          'Wa|tch it go.',//3
          'Lo|ok at th|e st|ars',//4
          'In th|e sk|y.',//5
          'It|’s ti|me fo|r be|d, sn|ake.',//6
          'Sa|y, “Go|odbye.”',//7
        ],
        answers: ['0-10', '1-6', '2-2', '2-12', '4-10', '5-6', '6-16'],
        initialValue: ['0-10'],
      },
      Layout: `
        <div style='display: flex; flex-direction: row;position: relative;align-items: center;background-color: #fde9bc; padding: 20px;'>
          <div style='width: 50%; margin-left: 20px; color: #ec870e;text-align: center;'>
            <div><input id='0' type='Circle' /></div>
            <div><input id='1' type='Circle' /></div>
            <div><input id='2' type='Circle' /></div>
            <div><input id='3' type='Circle' /></div>
            <div><input id='4' type='Circle' /></div>
            <div><input id='5' type='Circle' /></div>
            <div><input id='6' type='Circle' /></div>
            <div><input id='7' type='Circle' /></div>
          </div>
          <div style='width: '50%'>
            <img src="img/FriendsPlus/Page43/E3/title.jpg" style="width: 100%">
          </div>
        </div>
      `,
    },
  },
  4: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P43-E4',
    audio: 'img/FriendsPlus/Page43/Audio/audio-e4-p43.mp3',
    video: '',
    component: D1,
    exerciseKey: 'img/FriendsPlus/Page43/E4/Key/answerKey.png',
    isAllowSubmit: false,
    maxLength: 2,
    textAlign: 'center',
    question: [],
    questionImage: [
      [
        // Column1
        { url: 'img/FriendsPlus/Page43/E4/1.jpg' },
        { url: 'img/FriendsPlus/Page43/E4/2.jpg', audioUrl: 'img/FriendsPlus/Page43/Audio/tieude-e4-p43.mp3' },
        { url: 'img/FriendsPlus/Page43/E4/3.jpg' },
      ],
      [
        // Column2
        { url: 'img/FriendsPlus/Page43/E4/4.jpg' },
      ],
      [
        // Column3
        { url: 'img/FriendsPlus/Page43/E4/5.jpg' },
        { url: 'img/FriendsPlus/Page43/E4/6.jpg', input: true, answer: "sk" },
        { url: 'img/FriendsPlus/Page43/E4/7.jpg' },
      ],
      [
        // Column4
        { url: 'img/FriendsPlus/Page43/E4/8.jpg' },
      ],
      [
        // Column5
        { url: 'img/FriendsPlus/Page43/E4/9.jpg' },
        { url: 'img/FriendsPlus/Page43/E4/10.jpg', input: true, answer: "sm" },
        { url: 'img/FriendsPlus/Page43/E4/11.jpg' },
        { url: 'img/FriendsPlus/Page43/E4/12.jpg', input: true, answer: "sn" },
        { url: 'img/FriendsPlus/Page43/E4/13.jpg' },
        { url: 'img/FriendsPlus/Page43/E4/14.jpg', input: true, answer: "st" },
        { url: 'img/FriendsPlus/Page43/E4/15.jpg' },
      ],
    ]
  },
  5: { // Exercise num
    unit: 'Unit 6',
    id: 'SB3-U6-P43-E5',
    audio: '',
    video: '',
    component: UI,
    recorder: true,
    question: [],
    questionImage: [[{ url: 'img/FriendsPlus/Page43/E5/1.jpg' }]],
  },
}

export default json;